module.exports = __webpack_public_path__ + "img/spiral-details19.10cc0300.png";